import { Resources, type TFunction } from "Translations/Resources";
import { formatCurrency } from "Utils/CurrencyUtils";

const RESOURCES = Resources.Customer.Pay;

export const getPayButtonLabel = (
  t: TFunction,
  amount?: number | null,
  currencyCode?: string | null,
) => {
  if (!amount || !currencyCode) {
    return t(RESOURCES.PayButton);
  }

  return t(RESOURCES.PayButtonWithAmount, {
    amount: formatCurrency({ amount, currencyCode, minDecimalPlaces: 2 }),
  });
};
